export const snackbarError = (error: string) => ({
  type: 'lumahealth/ACTION_MESSAGE_ERROR_SNACKBAR',
  error,
});

export const snackbarSuccess = (notification: string) => ({
  type: 'lumahealth/ACTION_MESSAGE_SUCCESS_SNACKBAR',
  notification,
});
